<template>
  <div>
    <div class="mb-2 d-flex justify-content-end">
      <b-button
        v-if="itemData && itemData.id"
        variant="outline-primary"
        :to="'/app/tasks/add?id_guides=' + itemData.id"
      >
        <feather-icon icon="FileTextIcon" />
        {{ $t('guides.createTask.action') }}
      </b-button>
    </div>
    <validation-observer ref="simpleRules">
      <guides-item-form />
      <save-button
        :save-action="submitForm"
        :is-disabled="submitStatus"
      />
    </validation-observer>

    <create-task-from-guide-modal />
  </div>
</template>

<script>
import { ValidationObserver } from 'vee-validate'
import { BButton } from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import SaveButton from '@/layouts/components/common/SaveButton.vue'
import GuidesItemForm from '@/views/Guides/ItemForm.vue'
import CreateTaskFromGuideModal from '@/views/Guides/Components/CreateTaskFromGuideModal.vue'

export default {
  name: 'Edit',
  components: {
    GuidesItemForm,
    ValidationObserver,
    SaveButton,
    BButton,
    CreateTaskFromGuideModal,
  },
  data: () => ({
    submitStatus: false,
  }),
  computed: {
    itemData() {
      return this.$store.getters['guides/dataItem']
    },
    saveData() {
      return this.$store.getters['guides/dataSaveStatus']
    },
    form() {
      return this.$store.getters['guides/createTaskGuideModal']
    },
  },
  watch: {
    saveData(val) {
      if (val?.status === true) {
        this.showToast({
          variant: 'success', title: this.$t('common.toast.success'), icon: 'CheckIcon', text: val.message,
        })
      } else if (val?.status === false) {
        this.showToast({
          variant: 'danger', title: this.$t('common.toast.error'), icon: 'XIcon', text: val.message,
        })
        this.submitStatus = false
      }
      this.getDataItem()
    },
  },
  created() {
    this.getDataItem()
  },
  methods: {
    getDataItem() {
      this.$store.dispatch('guides/getDataItem', this.$route.params.id)
    },
    submitForm() {
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          this.submitStatus = true
          this.$store.dispatch('guides/saveData', this.itemData)
        } else {
          this.showToast({
            title: this.$t('common.toast.warning'), icon: 'XIcon', text: this.$t('common.requiredFields'), variant: 'danger',
          })
        }
      })
    },
    showToast(params) {
      this.$toast({ component: ToastificationContent, props: params }, { position: 'bottom-center' })
    },
  },
}
</script>
